/**
 * The committed, trained models (written by `pnpm lab:train`). Imported as JSON modules
 * rather than read with node:fs so `@clutch/core` stays pure and browser-safe; the path is
 * resolved relative to this file at build time (repo-root `models/`).
 */
import type { Intelligence } from '../contracts.js';
import { WinProbModelSchema } from '../contracts.js';
import { DetectorModelSchema } from './detector.js';
import { createIntelligence } from './intelligence.js';
import winprobJson from '../../../../models/winprob.v1.json' with { type: 'json' };
import detectorJson from '../../../../models/detector.v1.json' with { type: 'json' };

export const DEFAULT_WINPROB_MODEL = WinProbModelSchema.parse(winprobJson);
export const DEFAULT_DETECTOR_MODEL = DetectorModelSchema.parse(detectorJson);

/** `Intelligence` backed by models/winprob.v1.json + models/detector.v1.json. */
export function loadDefaultIntelligence(): Intelligence {
  return createIntelligence(DEFAULT_WINPROB_MODEL, DEFAULT_DETECTOR_MODEL);
}
